<div class="risk-container d-flex flex-column">
  <div class="overall-risk-container d-flex flex-column flex-md-row justify-content-between" id="overallRisk">
    <div class="overall-risk">
      <div class="d-flex flex-nowrap">
        <img src="/assets/icons/icon-risk-overall.svg" width="24" height="24" alt="Child Safety Risk Icon" />
        <h3 class="d-inline">Child Safety Risk</h3>
      </div>
      <risk-severity [risk]="data?.overallRisk"></risk-severity>
    </div>
    <p>Pixalate’s assessment of overall Child Safety Risk at the app developer level based on three main risk
      categories: Identity, Compliance, and Traffic Quality.</p>
  </div>

  <div class="more-info-container d-flex flex-column">
    <div class="more-info-item">
      <div>
        <img src="/assets/icons/icon-search.svg" width="18" height="18" alt="Identity Risk Icon" />
        <span class="more-info-title">Identity Risk:</span>
        <risk-heat-meter version="v2" [risk]='data?.identityRisk'></risk-heat-meter>
      </div>
      <span>Does the developer make their name and contact information accessible?</span>
    </div>
    <div class="more-info-item">
      <div>
        <img src="/assets/icons/icon-compliance.svg" width="18" height="18" alt="Compliance Risk Icon" />
        <span class="more-info-title">Compliance Risk:</span>
        <risk-heat-meter version="v2" [risk]='data?.complianceRisk'></risk-heat-meter>
      </div>
      <span>Does the developer follow industry best practices, app store guidelines, and/or privacy regulation
        requirements?</span>
    </div>
    <div class="more-info-item">
      <div>
        <img src="/assets/icons/icon-warning.svg" width="18" height="18" alt="Traffice Quality Risk Icon" />
        <span class="more-info-title">Traffic Quality Risk:</span>
        <risk-heat-meter version="v2" [risk]='data?.trafficQualityRisk'></risk-heat-meter>
      </div>
      <span>Does the developer expose users to risks associated with advertising fraud?</span>
    </div>
  </div>
</div>